export default __webpack_public_path__ + "static/media/BrainBreak cards4.b6637e41.png";